/**
 * Filtra profesionales o agendas de estudio por sede (portal premium, multiples sedes).
 * Horarios sin branchId se consideran sede principal.
 */
export function filterByPortalBranch(items, { versionPortal, selectedBranch, branches }) {
  if (
    versionPortal !== 'premium' ||
    !selectedBranch ||
    !items?.length ||
    branches?.length < 2
  ) {
    return items ?? [];
  }

  const mainBranch = branches.find((b) => b.isMain) || branches[0];
  const mainBranchId = mainBranch?._id?.toString?.() || mainBranch?._id;
  const selectedBranchId = selectedBranch?.toString?.() || selectedBranch;
  const isMainBranchSelected =
    mainBranchId && selectedBranchId === mainBranchId;

  return items.filter((item) => {
    const hasHoursInBranch = item.scheduleConfig?.hours?.some(
      (hour) =>
        (hour.branchId?.toString?.() || hour.branchId) === selectedBranchId,
    );
    const hasNoBranchConfigured = !item.scheduleConfig?.hours?.some(
      (hour) => hour.branchId,
    );

    if (isMainBranchSelected) {
      return hasHoursInBranch || hasNoBranchConfigured;
    }
    return hasHoursInBranch;
  });
}
